// After a deploy, a tab that was already open still asks for the old build's
// page files, which are gone, so opening a page fails. Reloading picks up the
// new build. The error page does it, once the address shows the page that
// failed, and at most once a minute so a real outage can't loop.
const KEY = 'pred-hub:stale-reload'

export function isStaleBuildError(error) {
  const message = String(error?.message ?? error ?? '')
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(message)
}

// True when it reloaded (the page is going away), false when it already
// tried recently and the caller should show the error instead.
export function reloadForNewBuild() {
  try {
    const last = Number(sessionStorage.getItem(KEY)) || 0
    if (Date.now() - last < 60_000) return false
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch {
    // Storage can be blocked; reloading once is still the right call.
  }
  window.location.reload()
  return true
}
